import { useTranslate } from "ra-core";
import { useCallback } from "react";
import { leadStatusLabelFor } from "../domain/leads/leadStatusModel";
import { useLeadStatuses } from "./useLeadStatuses";

/** The status label: the owner's once renamed (both languages); an unrenamed system status is translated; a value the
 * list lacks shows its translation, else the raw value. */
export const useLeadStatusLabel = () => {
  const translate = useTranslate();
  const statuses = useLeadStatuses();
  return useCallback(
    (value: string) => leadStatusLabelFor(statuses, value, translate),
    [translate, statuses],
  );
};
